import CandidatePage from './Candidate.container';

export default CandidatePage;
